import React from 'react';
import { Link } from 'react-router-dom';
import { Content, Icon, Button } from 'rsuite';
import * as PERMISSIONS from '../../../constants/permissions/inventory';
import { viewAccess, modifyAccess } from '../../../helpers/permission';
import AccessControl from '../../../components/AccessControl';
import AccessDenied from '../../../components/AccessDenied';
import InventoryPageLayout from '../../../containers/inventory/PageLayout';
import PageHeader from '../../../components/PageHeader';
import SearchPanel from '../../../components/inventory/SearchPanel';
import InventoryPackageList from '../../../containers/inventory/PackageList';
import InventorySearchPackage from '../../../containers/inventory/Search/Package';
import { inventoryCreatePackagePath } from '../../Paths';

export default () => (
  <InventoryPageLayout>
    <AccessControl
      allowOnlyFor={viewAccess(PERMISSIONS.PACKAGE)}
      fallback={<AccessDenied />}
    >
      <PageHeader title="Packages">
        <SearchPanel bordered>
          <AccessControl allowOnlyFor={modifyAccess(PERMISSIONS.PACKAGE)}>
            <Link to={inventoryCreatePackagePath}>
              <Button appearance="primary">
                <Icon icon="plus-circle" /> Create New
              </Button>
            </Link>
          </AccessControl>
          <InventorySearchPackage placeholder="Search name or description" />
        </SearchPanel>
      </PageHeader>
      <Content>
        <InventoryPackageList />
      </Content>
    </AccessControl>
  </InventoryPageLayout>
);
